// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-background {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.065);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-spinner-background {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.065);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.available {
  background-color: var(--ion-color-success);
}

.busy {
  background-color: #ed143d;
}

.pending {
  background-color: var(--ion-color-warning);
}

ion-card {
  margin: 20px 10px;
}
ion-card .div-horizental {
  width: 6px;
  height: 100%;
  z-index: 10;
  position: absolute;
  left: 0;
  top: 0;
}
ion-card:first-child {
  margin: 10px 10px 20px;
}
ion-card ion-item-sliding,
ion-card ion-item {
  height: 100%;
}
ion-card .wrapper {
  width: 100%;
  position: relative;
  padding-left: 6px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
ion-card .image-swiper-container {
  --swiper-pagination-color: #ed143d;
  width: 100%;
  overflow: hidden;
  height: 0;
  transition: height 0.3s ease-in-out;
}
ion-card .image-swiper-container.show {
  height: 280px;
}
ion-card .image-swiper-container swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100% !important;
}
ion-card .image-swiper-container swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
ion-card ion-item::part(native) {
  --inner-padding-end: 0;
  --padding-start: 0;
  height: 100%;
}
ion-card ion-card-header {
  padding: 0 5px 0 10px;
}
ion-card ion-card-header ion-card-title {
  display: flex;
  align-items: center;
  gap: 10px;
  -webkit-padding-start: 10px;
          padding-inline-start: 10px;
  justify-content: center;
}
ion-card ion-card-header ion-card-title ion-avatar {
  margin: 0 auto;
}
ion-card ion-card-header ion-card-title ion-avatar img {
  background-size: cover;
  border-radius: 15px;
  height: 45px;
  width: 45px;
}
ion-card ion-card-header ion-card-title .resource-type-icon {
  font-size: 40px;
}
ion-card ion-card-header ion-card-title ion-label {
  font-size: 20px;
  flex-grow: 3;
  margin-bottom: 5px;
}
ion-card ion-card-header ion-card-title ion-label .displayName,
ion-card ion-card-header ion-card-title ion-label .emailAddress {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
ion-card ion-card-header ion-card-title ion-label .emailAddress {
  color: #6e6e6e;
  font-size: 12px;
  margin: 2px;
  font-weight: 500;
  word-break: break-word;
}
ion-card ion-card-header ion-card-subtitle {
  display: flex;
  font-size: 11px;
  align-items: center;
}
ion-card ion-card-header ion-card-subtitle .address {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
ion-card ion-card-header ion-card-subtitle .location-icon {
  margin-right: 2.5px;
  font-size: 11px;
}
ion-card ion-card-header ion-card-subtitle .favorite-icon {
  margin-left: auto;
  font-size: 24px;
  cursor: pointer;
  transform: translateY(5px);
}
ion-card ion-card-content {
  padding: 5px 5px 8px 10px;
  display: flex;
  align-items: center;
  flex: 1;
}
ion-card ion-card-content .chips-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
ion-card ion-card-content ion-chip {
  padding-inline: 10px;
  font-size: 12px;
}
ion-card ion-card-content ion-chip ion-icon {
  margin-right: 3.5px;
}
ion-card ion-card-content ion-chip.dumb {
  pointer-events: none;
}
ion-card ion-card-content ion-chip .book-options-icon {
  font-size: 12px;
  margin-left: 5px;
  margin-right: 0;
}

ion-popover.booking-options ion-item {
  font-size: 14px;
}
ion-popover.booking-options ion-item ion-icon {
  margin-right: 10px;
}

ion-popover.resource-images-popover {
  --height: unset;
  --width: 420px;
}
ion-popover.resource-images-popover::part(content) {
  padding: 7px;
}
ion-popover.resource-images-popover .image-swiper-container {
  --swiper-pagination-color: #ed143d;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
}
ion-popover.resource-images-popover .image-swiper-container swiper-slide .image-container {
  width: 100%;
  height: 280px;
  overflow: hidden;
}
ion-popover.resource-images-popover .image-swiper-container swiper-slide .image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
ion-popover.resource-images-popover .resource-images-info {
  padding-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
ion-popover.resource-images-popover .resource-images-info ion-label {
  font-weight: 600;
}
ion-popover.resource-images-popover .resource-images-info ion-icon {
  font-size: 16px;
  color: #ed143d;
}
ion-popover.resource-images-popover .resource-images-info ion-chip {
  cursor: default;
}

ion-popover.display-name {
  --width: 275px;
}
ion-popover.display-name ion-icon {
  font-size: 16px;
}
ion-popover.display-name ion-label {
  margin: 5px 10px;
}
ion-popover.display-name ion-label .displayName,
ion-popover.display-name ion-label .address,
ion-popover.display-name ion-label .emailAddress {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 7px 0;
  word-break: break-word;
}
ion-popover.display-name ion-label .displayName div,
ion-popover.display-name ion-label .address div,
ion-popover.display-name ion-label .emailAddress div {
  display: flex;
}
ion-popover.display-name ion-label .address {
  font-size: 12px !important;
}
ion-popover.display-name ion-label .address ion-icon {
  font-size: 16px;
}
ion-popover.display-name ion-label .displayName {
  font-size: 15px;
}
ion-popover.display-name ion-label .emailAddress ion-icon {
  color: #6e6e6e;
}
ion-popover.display-name ion-label .emailAddress small {
  color: #6e6e6e;
  font-size: 12px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/place/place.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AACA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEF;;AACA;EACE,0CAAA;AAEF;;AAAA;EACE,yBAAA;AAGF;;AADA;EACE,0CAAA;AAIF;;AADA;EACE,iBAAA;AAIF;AAHE;EACE,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AAKJ;AAHE;EACE,sBAAA;AAKJ;AAFE;;EAEE,YAAA;AAIJ;AAFE;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAIJ;AAFE;EACE,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,mCAAA;AAIJ;AAFI;EACE,aAAA;AAIN;AADI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAGN;AADM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAGR;AACE;EACE,sBAAA;EACA,kBAAA;EACA,YAAA;AACJ;AACE;EACE,qBAAA;AACJ;AAAI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;UAAA,0BAAA;EACA,uBAAA;AAEN;AAAM;EACE,cAAA;AAER;AAAQ;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAEV;AACM;EACE,eAAA;AACR;AACM;EACE,eAAA;EACA,YAAA;EACA,kBAAA;AACR;AAAQ;;EAEE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;AAEV;AAAQ;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AAEV;AAEI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AAAN;AACM;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;AACR;AACM;EACE,mBAAA;EACA,eAAA;AACR;AACM;EACE,iBAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;AACR;AAGE;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,OAAA;AADJ;AAEI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAAN;AAEI;EACE,oBAAA;EACA,eAAA;AAAN;AACM;EACE,mBAAA;AACR;AACM;EACE,oBAAA;AACR;AACM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AACR;;AAME;EACE,eAAA;AAHJ;AAII;EACE,kBAAA;AAFN;;AAOA;EACE,eAAA;EACA,cAAA;AAJF;AAKE;EACE,YAAA;AAHJ;AAKE;EACE,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAHJ;AAKM;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AAHR;AAIQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAFV;AAOE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AALJ;AAMI;EACE,gBAAA;AAJN;AAMI;EACE,eAAA;EACA,cAAA;AAJN;AAMI;EACE,eAAA;AAJN;;AASA;EACE,cAAA;AANF;AAOE;EACE,eAAA;AALJ;AAOE;EACE,gBAAA;AALJ;AAMI;;;EAGE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;AAJN;AAKM;;;EACE,aAAA;AADR;AAII;EACE,0BAAA;AAFN;AAKM;EACE,eAAA;AAHR;AAMI;EACE,eAAA;AAJN;AAOM;EACE,cAAA;AALR;AAOM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AALR","sourcesContent":[".spinner-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.065);\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.page-spinner-background {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.065);\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.available {\n  background-color: var(--ion-color-success);\n}\n.busy {\n  background-color: #ed143d;\n}\n.pending {\n  background-color: var(--ion-color-warning);\n}\n\nion-card {\n  margin: 20px 10px;\n  .div-horizental {\n    width: 6px;\n    height: 100%;\n    z-index: 10;\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n  &:first-child {\n    margin: 10px 10px 20px;\n  }\n\n  ion-item-sliding,\n  ion-item {\n    height: 100%;\n  }\n  .wrapper {\n    width: 100%;\n    position: relative;\n    padding-left: 6px;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n  .image-swiper-container {\n    --swiper-pagination-color: #ed143d;\n    width: 100%;\n    overflow: hidden;\n    height: 0;\n    transition: height 0.3s ease-in-out;\n\n    &.show {\n      height: 280px;\n    }\n\n    swiper-slide {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 100% !important;\n      // flex-shrink: 0;\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n  ion-item::part(native) {\n    --inner-padding-end: 0;\n    --padding-start: 0;\n    height: 100%;\n  }\n  ion-card-header {\n    padding: 0 5px 0 10px;\n    ion-card-title {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      padding-inline-start: 10px;\n      justify-content: center;\n\n      ion-avatar {\n        margin: 0 auto;\n\n        img {\n          background-size: cover;\n          border-radius: 15px;\n          height: 45px;\n          width: 45px;\n        }\n      }\n      .resource-type-icon {\n        font-size: 40px;\n      }\n      ion-label {\n        font-size: 20px;\n        flex-grow: 3;\n        margin-bottom: 5px;\n        .displayName,\n        .emailAddress {\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          -webkit-line-clamp: 1;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n        .emailAddress {\n          color: #6e6e6e;\n          font-size: 12px;\n          margin: 2px;\n          font-weight: 500;\n          word-break: break-word;\n        }\n      }\n    }\n    ion-card-subtitle {\n      display: flex;\n      font-size: 11px;\n      align-items: center;\n      .address {\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n      .location-icon {\n        margin-right: 2.5px;\n        font-size: 11px;\n      }\n      .favorite-icon {\n        margin-left: auto;\n        font-size: 24px;\n        cursor: pointer;\n        transform: translateY(5px);\n      }\n    }\n  }\n  ion-card-content {\n    padding: 5px 5px 8px 10px;\n    display: flex;\n    align-items: center;\n    flex: 1;\n    .chips-container {\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n    }\n    ion-chip {\n      padding-inline: 10px;\n      font-size: 12px;\n      ion-icon {\n        margin-right: 3.5px;\n      }\n      &.dumb {\n        pointer-events: none;\n      }\n      .book-options-icon {\n        font-size: 12px;\n        margin-left: 5px;\n        margin-right: 0;\n      }\n    }\n  }\n}\n\nion-popover.booking-options {\n  ion-item {\n    font-size: 14px;\n    ion-icon {\n      margin-right: 10px;\n    }\n  }\n}\n\nion-popover.resource-images-popover {\n  --height: unset;\n  --width: 420px;\n  &::part(content) {\n    padding: 7px;\n  }\n  .image-swiper-container {\n    --swiper-pagination-color: #ed143d;\n    width: 100%;\n    overflow: hidden;\n    border-radius: 8px;\n    swiper-slide {\n      .image-container {\n        width: 100%;\n        height: 280px;\n        overflow: hidden;\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n      }\n    }\n  }\n  .resource-images-info {\n    padding-top: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    ion-label {\n      font-weight: 600;\n    }\n    ion-icon {\n      font-size: 16px;\n      color: #ed143d;\n    }\n    ion-chip {\n      cursor: default;\n    }\n  }\n}\n\nion-popover.display-name {\n  --width: 275px;\n  ion-icon {\n    font-size: 16px;\n  }\n  ion-label {\n    margin: 5px 10px;\n    .displayName,\n    .address,\n    .emailAddress {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      margin: 7px 0;\n      word-break: break-word;\n      div {\n        display: flex;\n      }\n    }\n    .address {\n      font-size: 12px !important;\n      // margin-left: -2px;\n\n      ion-icon {\n        font-size: 16px;\n      }\n    }\n    .displayName {\n      font-size: 15px;\n    }\n    .emailAddress {\n      ion-icon {\n        color: #6e6e6e;\n      }\n      small {\n        color: #6e6e6e;\n        font-size: 12px;\n        font-weight: 500;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
